export default "__VITE_ASSET__CQmXMC7w__"